import { render, staticRenderFns } from "./SVGEditor.vue?vue&type=template&id=2d0b9791&scoped=true"
import script from "./SVGEditor.vue?vue&type=script&lang=js"
export * from "./SVGEditor.vue?vue&type=script&lang=js"
import style0 from "./SVGEditor.vue?vue&type=style&index=0&id=2d0b9791&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b9791",
  null
  
)

export default component.exports